import React from "react";
import { Row } from "antd";
import NotepadCalendar from "../Calendar/NotepadCalendar";

const PatientNotepadTable = () => {
  return (
    <Row className="relative my-14 w-full">
      <NotepadCalendar />
    </Row>
  );
};

export default PatientNotepadTable;
